import { render, staticRenderFns } from "./shorttable.vue?vue&type=template&id=69b4da57"
import script from "./shorttable.vue?vue&type=script&lang=js"
export * from "./shorttable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports